import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { get, post } from "../../../components/Utils/CallApi";
import { setPageLoadingTrue, setPageLoadingFalse, setError } from "../appSlice";

export const saveTags = createAsyncThunk(
  "tags/saveTags",
  async ({ categoryData }, { dispatch, getState, rejectWithValue }) => {
    try {
      dispatch(setPageLoadingTrue());
      const state = getState();
      const response = await post(
        "sections/tags/save",
        categoryData,
        state.app
      );

      if (response.status === "failure") {
        dispatch(setError(response.result));
        return rejectWithValue(response.result);
      }

      return response.data;
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    } finally {
      dispatch(setPageLoadingFalse());
    }
  }
);

export const listTags = createAsyncThunk(
  "tags/listTags",
  async ({ companyId }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setPageLoadingTrue());
      const params = `companyId=${companyId}`;
      const response = await get("sections/tags/list", params);

      if (response.status === "failure") {
        dispatch(setError(response.result));
        return rejectWithValue(response.result);
      }

      return response.result || [];
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    } finally {
      dispatch(setPageLoadingFalse());
    }
  }
);

export const listItems = createAsyncThunk(
  "tags/listItems",
  async ({ companyId, id, page, limit }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setPageLoadingTrue());
      const params = `companyId=${companyId}&tagIds=${id}&page=${page}&limit=${limit}`;
      const response = await get("sections/tags/items/list", params);

      if (response.status === "failure") {
        dispatch(setError(response.result));
        return rejectWithValue(response.result);
      }

      return response.result || [];
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    } finally {
      dispatch(setPageLoadingFalse());
    }
  }
);

export const deleteTag = createAsyncThunk(
  "tags/delete",
  async ({ id }, { dispatch, getState, rejectWithValue }) => {
    try {
      dispatch(setPageLoadingTrue());
      const state = getState();

      const response = await post("sections/tags/delete", { id }, state.app);

      if (response.status === "failure") {
        dispatch(setError(response.result));
        return rejectWithValue(response.result);
      }

      return id;
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    } finally {
      dispatch(setPageLoadingFalse());
    }
  }
);

export const editTag = createAsyncThunk(
  "tags/editTag",
  async ({ id }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setPageLoadingTrue());
      const params = `id=${id}`;
      const response = await get("sections/tags/get", params);

      if (response.status === "failure") {
        dispatch(setError(response.result));
        return rejectWithValue(response.result);
      }

      return response.result || [];
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    } finally {
      dispatch(setPageLoadingFalse());
    }
  }
);

const tagsSlice = createSlice({
  name: "tags",
  initialState: {
    tags: [],
    items: [],
    loading: false,
    error: null,
  },
  reducers: {
    setTags: (state, action) => {
      state.tags = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(saveTags.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveTags.fulfilled, (state, action) => {
        state.loading = false;
        state.tags = action.payload;
      })
      .addCase(saveTags.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(listTags.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(listTags.fulfilled, (state, action) => {
        state.loading = false;
        state.tags = action.payload;
      })
      .addCase(listTags.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(listItems.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(listItems.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(listItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setTags } = tagsSlice.actions;
export default tagsSlice.reducer;
